<template>
  <div id="positionType">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "positionType",
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/exhibition/booth/type/PositionType.vue